var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29998 3.75H8.9508C11.2362 3.75 12.3789 3.75 12.8127 4.16047C13.1877 4.51528 13.3539 5.03796 13.2526 5.54416C13.1355 6.12976 12.2026 6.78964 10.3367 8.1094L7.28829 10.2656C5.42243 11.5854 4.48949 12.2452 4.37238 12.8308C4.27114 13.337 4.43731 13.8597 4.81227 14.2145C5.24605 14.625 6.38877 14.625 8.6742 14.625H12.0311M6 3.75C6 4.99264 4.99264 6 3.75 6C2.50736 6 1.5 4.99264 1.5 3.75C1.5 2.50736 2.50736 1.5 3.75 1.5C4.99264 1.5 6 2.50736 6 3.75ZM16.5 14.25C16.5 15.4926 15.4926 16.5 14.25 16.5C13.0074 16.5 12 15.4926 12 14.25C12 13.0074 13.0074 12 14.25 12C15.4926 12 16.5 13.0074 16.5 14.25Z",
    stroke: "#344868",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.da66b0d6149c284dbe5a4b89408fe084.svg";
export { ForwardRef as ReactComponent };